<fz-filter-panel
  [facet]="facet()"
  [filters]="filters()"
  (clear)="clear.emit()"
  (filterChange)="selectionChange($event)"
></fz-filter-panel>
